import React from 'react';
import useLicenseStore from '../store/licenseStore';
import SCDLogo from '../components/SCDLogo';
import RexPage from './RexPage';
import { KeyRound, Clock } from 'lucide-react';

/** Écran plein-page affiché quand la licence est expirée :
 *  le message « licence expirée » devient la page de retour d'expérience. */
export default function RexExpiredScreen() {
  const { expiredInfo, clearLicense } = useLicenseStore();

  return (
    <div className="min-h-screen bg-ink-900 relative overflow-y-auto" data-testid="rex-expired-screen">
      <div className="absolute inset-0 bg-gradient-to-br from-background/95 via-background/85 to-background pointer-events-none" />
      <div className="relative z-10 py-8">
        <div className="flex flex-col items-center gap-2 mb-4">
          <SCDLogo size={56} />
          <h1 className="font-display text-2xl font-black text-foreground">SCD</h1>
          <div className="flex items-center gap-2 bg-warn/10 border border-warn/40 rounded-full px-4 py-1.5 text-xs text-warn font-medium" data-testid="rex-expired-badge">
            <Clock className="w-3.5 h-3.5" /> Votre licence a expiré — merci d'avoir joué !
          </div>
        </div>

        <div className="max-w-2xl mx-auto surface-card bg-card/95 backdrop-blur-xl border-ink-600">
          {expiredInfo?.rexSubmitted ? (
            <div className="text-center py-12 px-6" data-testid="rex-already-submitted">
              <p className="text-sm text-slate-300">
                Votre retour d'expérience a déjà été envoyé — merci {expiredInfo?.holderName || ''} !
              </p>
            </div>
          ) : (
            <RexPage licenseKey={expiredInfo?.licenseKey} holderName={expiredInfo?.holderName} />
          )}
        </div>

        <div className="text-center mt-5">
          <button
            type="button"
            onClick={clearLicense}
            className="inline-flex items-center gap-2 text-xs text-slate-500 hover:text-slate-300 uppercase tracking-wider transition-colors"
            data-testid="rex-change-key"
          >
            <KeyRound className="w-3.5 h-3.5" /> Utiliser une autre clé
          </button>
        </div>
      </div>
    </div>
  );
}
